import { Base_Url } from "../../../BaseURL/BaseUrl";
import { getApiWithAuthorization, postApiWithAuthorization } from "../../ApiMethods/ApiMethod";

const StatusesUrl = `${Base_Url}/Status`;

export const GetStatusList = async (params) => {
    const res = await postApiWithAuthorization(`${StatusesUrl}/GetStatusList`, params);
    return res;
};

export const AddUpdateStatus = async (params) => {
    const res = await postApiWithAuthorization(`${StatusesUrl}/AddUpdateStatus?ModuleName=${params.ModuleName}`, params);
    return res;
};
export const GetStatusModel = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${StatusesUrl}/GetStatusModel?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&StatusKeyID=${KeyID}`);
    return res;
};

export const ChangeStatusStatus = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${StatusesUrl}/ChangeStatusStatus?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&StatusKeyID=${KeyID}`);
    return res;
};

export const DeleteStatus = async (ModuleName, KeyID, UserKeyID) => {
    const res = await getApiWithAuthorization(`${StatusesUrl}/DeleteStatus?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}&StatusKeyID=${KeyID}`);
    return res;
};
export const GetStatusLookupList = async (ModuleName, UserKeyID) => {
    const res = await getApiWithAuthorization(`${StatusesUrl}/GetStatusLookupList?ModuleName=${ModuleName}&UserKeyID=${UserKeyID}`);
    return res;
};